import { InjectionToken } from '@angular/core';
export { IConfigService, ConfigKeysEnum } from './config';

export const SERVICE_TOKEN = new InjectionToken('Core.ConfigService');
